import React, { useState, Fragment, useEffect } from 'react';
import FormSection from 'components/sales/formSection/formSection';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import Regex from 'services/utils/regex/Regex';
import localization from 'assets/localization/localization';
import { handleValidateObj } from 'constants/objValues/objvalues';

const List = [
  { name: 'Hotel', id: 11 },
  { name: 'Mall', id: 10 },
];

const OptionList = [
  { name: 'Yes', id: 0 },
  { name: 'No', id: 1 },
];

const SiteFeature = ({ data, handleValue }) => {
  const siteFeature = {
    featureType: '',
    cinema: '',
    cinemaName: '',
    noOfScreens: '',
    valetAvaliable: '',
    corporatesPremises: '',
    keyTenants: '',
    noOfRestaurants: '',
    keyRestaurants: '',
    noOfValetDrivers: '',
    noOfParkingSlots: '',
  };

  const [siteFeatureData, setsiteFeatureData] = useState(siteFeature);
  const [featureType, setFeatureType] = useState();

  const handleFormData = () => {
    const isEmpty = handleValidateObj(siteFeatureData);
    if (siteFeatureData.featureType !== ' ') {
      let requestMall = [
        {
          cinema: [
            {
              cinema_availaible: siteFeatureData.cinema,
              cinema_name: siteFeatureData.cinemaName,
              no_of_screens: siteFeatureData.noOfScreens,
            },
          ],
          valet: [
            {
              valet_availaible: siteFeatureData.valetAvaliable,
              no_of_valet_drivers: siteFeatureData.noOfValetDrivers,
            },
          ],
          corporated_within_premises: siteFeatureData.corporatesPremises,
          key_tenants: siteFeatureData.keyTenants,
        },
      ];
      let requestHotel = [
        {
          no_of_restaurants: siteFeatureData.noOfRestaurants,
          key_restaurants: siteFeatureData.keyRestaurants,
          valet: [
            {
              valet_availaible: siteFeatureData.valetAvaliable,
              no_of_valet_drivers: siteFeatureData.noOfValetDrivers,
            },
          ],
        },
      ];
      handleValue({
        mall_site_type_data:
          siteFeatureData.featureType === 'Mall' ? requestMall : [],
        hotel_site_type_data:
          siteFeatureData.featureType === 'Hotel' ? requestHotel : [],
        total_no_of_parking_slot: siteFeatureData.noOfParkingSlots,
      });
    } else {
      handleValue(null);
    }
  };

  useEffect(() => {
    handleFormData();
  }, [siteFeatureData]);

  useEffect(() => {
    if (data.featureType) {
      const type = List.find((obj) => obj.id === data.featureType);
      if (type) {
        setFeatureType(type.name);
        setsiteFeatureData({ ...siteFeatureData, featureType: type.name });
      }
    }
  }, [data]);

  return (
    <FormSection title={localization.siteFeatureForm}>
      <form>
        {data && (data.featureType === 10 || data.featureType === 11) && (
          <div>
            <DropDownInput
              label={localization.featureType}
              value={featureType}
              data={List}
              required={true}
              isStarRequired={true}
              disabled={true}
              errorMsg={localization.isRequired}
              getIdValue={(val) => {
                setsiteFeatureData({
                  ...siteFeatureData,
                  featureType: val.value,
                });
              }}
            />

            {siteFeatureData.featureType === 'Mall' && (
              <Fragment>
                <DropDownInput
                  label={localization.cinema}
                  data={OptionList}
                  required={true}
                  isStarRequired={true}
                  errorMsg={localization.isRequired}
                  getIdValue={(val) => {
                    setsiteFeatureData({
                      ...siteFeatureData,
                      cinema: val.value,
                    });
                  }}
                />

                {siteFeatureData.cinema === 'Yes' && (
                  <Fragment>
                    <ConstantInput
                      label={localization.cinemaName}
                      regex={Regex.charSpace.test(siteFeatureData.cinemaName)}
                      errorMsg={
                        siteFeatureData.cinemaName
                          ? localization.alphaErrorMg
                          : localization.isRequired
                      }
                      type="text"
                      handleChange={(val) => {
                        setsiteFeatureData({
                          ...siteFeatureData,
                          cinemaName: val,
                        });
                      }}
                      required
                      isStarRequired={true}
                    />

                    <ConstantInput
                      label={localization.noOfScreens}
                      regex={Regex.number.test(siteFeatureData.noOfScreens)}
                      errorMsg={
                        siteFeatureData.noOfScreens
                          ? localization.numericErrorMg
                          : localization.isRequired
                      }
                      type="text"
                      handleChange={(val) => {
                        setsiteFeatureData({
                          ...siteFeatureData,
                          noOfScreens: val,
                        });
                      }}
                      required
                      isStarRequired={true}
                    />
                  </Fragment>
                )}

                <DropDownInput
                  label={localization.corporatesWthIn}
                  data={OptionList}
                  required={true}
                  isStarRequired={true}
                  errorMsg={localization.isRequired}
                  getIdValue={(val) => {
                    setsiteFeatureData({
                      ...siteFeatureData,
                      corporatesPremises: val.value,
                    });
                  }}
                />

                <ConstantInput
                  label={localization.keyTenant}
                  regex={Regex.charSpace.test(siteFeatureData.keyTenants)}
                  errorMsg={
                    siteFeatureData.keyTenants
                      ? localization.alphaErrorMg
                      : localization.isRequired
                  }
                  type="text"
                  value={siteFeatureData.keyTenants}
                  handleChange={(val) => {
                    setsiteFeatureData({
                      ...siteFeatureData,
                      keyTenants: val,
                    });
                  }}
                  required
                  isStarRequired={true}
                />
              </Fragment>
            )}

            {siteFeatureData.featureType === 'Hotel' && (
              <Fragment>
                <ConstantInput
                  label={localization.noOfRestaurants}
                  regex={Regex.numeric.test(siteFeatureData.noOfRestaurants)}
                  errorMsg={
                    siteFeatureData.noOfRestaurants === ''
                      ? localization.isRequired
                      : localization.numericErrorMg
                  }
                  type="text"
                  handleChange={(val) =>
                    setsiteFeatureData({
                      ...siteFeatureData,
                      noOfRestaurants: val,
                    })
                  }
                  required
                  isStarRequired={true}
                />

                <ConstantInput
                  label={localization.keyRestaurants}
                  regex={Regex.charSpace.test(siteFeatureData.keyRestaurants)}
                  errorMsg={
                    siteFeatureData.keyRestaurants === ''
                      ? localization.isRequired
                      : localization.alphaErrorMg
                  }
                  type="text"
                  handleChange={(val) =>
                    setsiteFeatureData({
                      ...siteFeatureData,
                      keyRestaurants: val,
                    })
                  }
                  required
                  isStarRequired={true}
                />
              </Fragment>
            )}
          </div>
        )}

        <Fragment>
          <DropDownInput
            label={localization.valetAvaliable}
            data={OptionList}
            required={true}
            isStarRequired={true}
            errorMsg={localization.requiredValet}
            getIdValue={(val) => {
              setsiteFeatureData({
                ...siteFeatureData,
                valetAvaliable: val.value,
              });
            }}
          />

          <ConstantInput
            label={localization.noOfParking}
            regex={Regex.numeric.test(siteFeatureData.noOfParkingSlots)}
            errorMsg={
              siteFeatureData.noOfParkingSlots
                ? localization.numericErrorMg
                : localization.requiredTotalParking
            }
            type="text"
            handleChange={(val) => {
              setsiteFeatureData({
                ...siteFeatureData,
                noOfParkingSlots: val,
              });
            }}
            required
            isStarRequired={true}
          />

          {siteFeatureData.valetAvaliable === 'Yes' && (
            <ConstantInput
              label={localization.noOfValetDrivers}
              regex={Regex.numeric.test(siteFeatureData.noOfValetDrivers)}
              errorMsg={
                siteFeatureData.noOfValetDrivers
                  ? localization.numericErrorMg
                  : localization.isRequired
              }
              type="text"
              handleChange={(val) => {
                setsiteFeatureData({
                  ...siteFeatureData,
                  noOfValetDrivers: val,
                });
              }}
              required
              isStarRequired={true}
            />
          )}
        </Fragment>
      </form>
    </FormSection>
  );
};

export default SiteFeature;
